/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReleaseDutyScheduleResponse
 */
export interface ReleaseDutyScheduleResponse {
    /**
     * 
     * @type {number}
     * @memberof ReleaseDutyScheduleResponse
     */
    createdAppointmentCount: number;
}

/**
 * Check if a given object implements the ReleaseDutyScheduleResponse interface.
 */
export function instanceOfReleaseDutyScheduleResponse(value: object): value is ReleaseDutyScheduleResponse {
    if (!('createdAppointmentCount' in value) || value['createdAppointmentCount'] === undefined) return false;
    return true;
}

export function ReleaseDutyScheduleResponseFromJSON(json: any): ReleaseDutyScheduleResponse {
    return ReleaseDutyScheduleResponseFromJSONTyped(json, false);
}

export function ReleaseDutyScheduleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleaseDutyScheduleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAppointmentCount': json['createdAppointmentCount'],
    };
}

export function ReleaseDutyScheduleResponseToJSON(json: any): ReleaseDutyScheduleResponse {
    return ReleaseDutyScheduleResponseToJSONTyped(json, false);
}

export function ReleaseDutyScheduleResponseToJSONTyped(value?: ReleaseDutyScheduleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAppointmentCount': value['createdAppointmentCount'],
    };
}

